export default __webpack_public_path__ + "static/media/1477.91e7d47c.png";